import { Card, FormLayout, Layout, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import { CsValidation as V, CsNonValidation as NV, CsValidationForm } from "../../shared/csValidationForm";
import TooltipHelper from "../../helpers/TooltipHelper";
import Switch from "react-switch/index";
import React from "react";

const SRReturns = props => {
  const {
    validatorClass,
    shippingDueByCustomer, insuranceRequired, repairs, exchanges,
    returnAddress,
    contactEmail, contactWebPage, contactPhone, contactOther,
    handleChange,
  } = props;

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("return.annotate.title.returns")}
      description={CsI18n.t('return.annotate.desc.returns')}>
      <Layout.Section>
        <Card sectioned>
          <CsValidationForm name={validatorClass} realtime={true}>
            <FormLayout>
              <FormLayout.Group>
                <div>
                  <p>
                    <CsI18n>Shipping due by customer</CsI18n>
                    {TooltipHelper.light(CsI18n.t('return.explain.due_by_customer'))}
                  </p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('shippingDueByCustomer')}
                    checked={shippingDueByCustomer}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("Shipping due by customer")}
                  />
                </div>
                <div>
                  <p>
                    <CsI18n>Insurance required</CsI18n>
                    {TooltipHelper.light(CsI18n.t("return.explain.insurance_required"))}
                  </p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('insuranceRequired')}
                    checked={insuranceRequired}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("Insurance required")}
                  />
                </div>
              </FormLayout.Group>

              <FormLayout.Group>
                <div>
                  <p>
                    <CsI18n>Repairs</CsI18n>
                    {TooltipHelper.light(CsI18n.t("return.explain.repairs"))}
                  </p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('repairs')}
                    checked={repairs}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("Repairs")}
                  />
                </div>
                <div>
                  <p>
                    <CsI18n>Exchanges</CsI18n>
                    {TooltipHelper.light(CsI18n.t("return.explain.exchanges"))}
                  </p>
                  <Switch
                    className="react-switch"
                    onChange={handleChange('exchanges')}
                    checked={exchanges}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    aria-label={CsI18n.t("Exchanges")}
                  />
                </div>
              </FormLayout.Group>

              <TextField
                label={CsI18n.t("Return address (if different than the store address)")}
                onChange={handleChange("returnAddress")}
                multiline value={returnAddress}
              />

              <FormLayout.Group
                title={CsI18n.t("Contact information (if different than the store contact information)")}>
                <V>
                  <TextField label={CsI18n.t("Email")} onChange={handleChange('contactEmail')}
                             value={contactEmail} />
                  <V.Item rule="email" title={CsI18n.t("Not a valid email.")} />
                </V>
                <V>
                  <TextField label={CsI18n.t("Web page")} onChange={handleChange('contactWebPage')}
                             value={contactWebPage} />
                  <V.Item rule="websiteWtProtocol" title={CsI18n.t("Not a valid website.")} />
                </V>
              </FormLayout.Group>

              <FormLayout.Group>
                <V>
                  <TextField label={CsI18n.t("Phone")} onChange={handleChange('contactPhone')}
                             value={contactPhone} />
                  <V.Item rule="phone" title={CsI18n.t("Not a valid phone number.")} />
                </V>
                <NV>
                  <TextField label={CsI18n.t("Other")} onChange={handleChange('contactOther')}
                             value={contactOther} multiline />  
                </NV>
              </FormLayout.Group>
            </FormLayout>
          </CsValidationForm>
        </Card>
      </Layout.Section>
    </Layout.AnnotatedSection>
  );
};

export default SRReturns;